import React from 'react';
import ReactDOM from 'react-dom';
import { unstable_HistoryRouter as HistRouter } from 'react-router-dom';

import App from './App';
import './index.css';
import reportWebVitals from './reportWebVitals';
import customHistory from './utils/customRouter/CustomHistory';
document.getElementById('prepare-env')?.addEventListener('prepare-env-loaded', () => {
  ReactDOM.render(
    <React.StrictMode>
      <HistRouter history={customHistory}>
        <App />
      </HistRouter>
    </React.StrictMode>,
    document.getElementById('root'),
  );
});
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
